<template>
  <nav class="top-nav">
    <v-row no-gutters>
    <v-col cols="3">
      <div>
        <ul>
          <li>
            <div class="top-menu"
                :class="activeView === 'allComments' ? 'top-menu--active' : ''"
                @click="activeView='allComments';getComment(false)"
            >
                <div class="top-menu__title">All comments</div>
            </div>
            </li>
            <li>
            <div class="top-menu"
                :class="activeView === 'sensitiveComments' ? 'top-menu--active' : ''"
                @click="activeView='sensitiveComments';getComment(true)"
            >
                <div class="top-menu__title">Sensitive comments</div>
            </div>
          </li>
        </ul>
      </div>
    </v-col>
    <v-col cols="9" class="text-right d-flex justify-end">
        <div v-if="downloadingFlag" class="d-flex box-container px-3" style="height: 2.4rem;">
          <v-btn :loading="true" icon></v-btn>
          <div class="pl-1 d-flex align-center">downloading...</div>
        </div>
        <v-menu offset-y offset-overflow max-width="400" v-if="!downloadingFlag">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              :disabled="!checkPermission(['data_export'])"
              class="box-container zoom-in ml-1"
            >
            <v-icon small class="mr-2">las la-cloud-download-alt</v-icon>
            <span>Export comments</span>
            </v-btn>
          </template>
          <v-list three-line>
            <v-list-item @click="downloadReport('filtered')">
              <v-list-item-avatar>
                <i class="las la-filter"></i>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>Currently Filtered</v-list-item-title>
                <v-list-item-subtitle>
                  Export the list of all comments
                  that are currently shown in the
                  table on the page.
                </v-list-item-subtitle>
              </v-list-item-content>
              </v-list-item>
              <v-list-item @click="downloadReport()">
              <v-list-item-avatar>
                  <i class="las la-user-friends"></i>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>All comments</v-list-item-title>
                <v-list-item-subtitle>
                  Export the list of all comments
                  that are present in {{user.company_name}}.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          class="box-container zoom-in ml-2"
          @click.stop="toggleFilter()"
        >
          <i class="las la-filter mr-2"></i>
          <span>Filter</span>
        </v-btn>
        <v-btn
          class="box-container zoom-in ml-2"
          v-if="isFilterApplied"
          icon
          @click="resetFilters()"
        >
        <v-icon>las la-sync-alt</v-icon>
      </v-btn>
    </v-col>
    </v-row>
  </nav>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'EmployeesSortbar',

  data () {
    return {
      // allCommentActive: true,
      // sensitiveCommentActive: false,
      commentsFilter: {},
      downloadingFlag: false,
      activeView: 'allComments',
      sensetiveComment: false
    };
  },

  props: {
    isFilterApplied: {
      required: true,
      type: Boolean
    },
    sortbarData: {
      requied: true,
      type: Object
    }
  },

  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler () {
        if (this.$route && this.$route.query && this.$route.query.filters) {
          const dashboardFilters = JSON.parse(this.$route.query.filters);
          this.commentsFilter = dashboardFilters;
        }
      }
    }
  },

  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    checkPermission (permission) {
      let flag = false;
      this.$lodash.each(this.user.permissions, (perm) => {
        this.$lodash.each(permission, (v) => {
          if (v === perm) {
            flag = true;
          }
        });
      });
      return flag;
    },
    downloadReport (type) {
      this.downloadingFlag = true;
      let reportFilters = {};
      if (type === 'filtered') {
        // send filters in api call
        let newFilter = {};
        let commentFilters = {};
        if (this.$route && this.$route.query && this.$route.query.filters) {
          commentFilters = JSON.parse(this.$route.query.filters);
        }
        const filters = Object.assign({}, commentFilters);
        if (filters && filters.filters) {
          delete filters.filters;
        }
        if (this.commentsFilter && commentFilters.filters) {
          this.$lodash.each(commentFilters.filters, (v, k) => {
            if (v && v.length > 0) {
              newFilter = {
                // [`${k}__in`]: v.join()
                [`user__profile__${k}__in`]: v.join()
              };
              reportFilters = {
                ...reportFilters,
                ...newFilter
              };
            }
          });
        }
        reportFilters = {
          ...reportFilters,
          ...filters,
          ...this.sortbarData
        };
      } else {
        // send blank all filters in api call
        reportFilters = {};
      }

      this.$store.dispatch('updateSnackbar', {
        color: 'warn',
        show: true,
        text: 'Generating report, Please wait!'
      });

      reportFilters = {
        ...reportFilters
      };
      // http://localhost:8000/feedback_bot/
      axios.get(`${process.env.VUE_APP_API_URL}response/download-list-excel?sensitive_comments=${this.sensetiveComment}`, {
        params: reportFilters
      }).then((response) => {
        // console.log('response', response);
        if (response && response.data && response.data.success) {
          if (response.data.file_response && response.data.file_response.report_url) {
            this.downloadingFlag = false;
            this.$forceUpdate();
            setTimeout(() => {
              window.open(response.data.file_response.report_url);
            }, 100);
          } else {
            this.downloadingFlag = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to generate report, Please try again later!'
            });
          }
          this.reportDialog = false;
        } else {
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to generate report, Please try again later!'
          });
          this.reportDialog = false;
        }
        this.downloadingFlag = false;
      }).catch((err) => {
        if (err.response.status === 429) {
          // this.loading = false;
          // this.open = false;
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          // this.loading = false;
          // this.open = false;
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to generate report, Please try again later!'
          });
        }
      });
    },
    toggleFilter () {
      this.$emit('toggleFilter');
    },
    resetFilters () {
      this.$emit('resetFilters');
    },
    getComment (val) {
      if (val) {
        this.sensetiveComment = true;
      }
      if (!val) {
        this.sensetiveComment = false;
      }
      this.$emit('getComment', val);
    }
    // getAllComment () {
    //   // this.allCommentActive = true;
    //   // this.sensitiveCommentActive = false;
    //   this.$emit('getAllComment', this.allCommentActive);
    // },
    // getSensetiveComment () {
    //   // this.allCommentActive = false;
    //   // this.sensitiveCommentActive = true;
    //   this.$emit('getSensetiveComment', this.sensitiveCommentActive);
    // }
  }
};
</script>

<style lang="scss" scoped>
.top-nav {
  // position: relative;
  padding: 12px 12px 0;
  // background-color: #050550;
  background-color: #050550;
  background-image: -webkit-gradient(linear,right top, left top,from(transparent),to(rgba(51,148,255,0.18)));
  ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    padding-left: 50px;
    li {
      position: relative;
      cursor: pointer;
      a {
        text-decoration: none;
      }
      .top-menu {
        // height: 55px;
        height: 48px;
        // border-top-left-radius: 0.375rem;
        border-top-left-radius: 0.5rem;
        // border-top-right-radius: 0.375rem;
        border-top-right-radius: 0.5rem;
        display: flex;
        align-items: center;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        // margin-right: 0.5rem;
        margin-right: 0.25rem;
        // color: var(--color-text);
        color: var(--bg);
        font-size: var(--content-size);
        position: relative;
        .top-menu__title {
          margin-left: 0.25rem;
          display: flex;
          align-items: center;
          white-space: nowrap;
          .top-menu__sub-icon {
            transition-property: background-color,
            border-color, color, fill, stroke, opacity, box-shadow, transform;
            transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
            transition-duration: 100ms;
            width: 1rem;
            height: 1rem;
            margin-left: 0.5rem;
          }
        }
        &.top-menu--active {
          display: flex;
          // background-color: #faf8fb;
          background-color: #ffffff;
          color: var(--primary-color);
          .top-menu__icon {
            color: var(--primary-dark);;
          }
          .top-menu__title {
            color: var(--color-headings);
            font-weight: var(--heading-weight);
          }
          &::before {
            content: "";
            width: 20px;
            height: 20px;
            margin-left: -19px;
            transform: rotate(90deg) scale(1.04);
            background-size: 100%;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='259.51' height='259.52' viewBox='0 0 259.51 259.52'%3E%3Cpath id='Path_143' data-name='Path 143' d='M8659.507,423.965c-.167-2.608.05-5.319-.19-8.211-.084-1.012-.031-2.15-.118-3.12-.113-1.25-.1-2.682-.236-4.061-.172-1.722-.179-3.757-.365-5.394-.328-2.889-.478-5.857-.854-8.61-.509-3.714-.825-7.252-1.38-10.543-.934-5.535-2.009-11.312-3.189-16.692-.855-3.9-1.772-7.416-2.752-11.2-1.1-4.256-2.394-8.149-3.687-12.381-1.1-3.615-2.366-6.893-3.623-10.493-1.3-3.739-2.917-7.26-4.284-10.7-1.708-4.295-3.674-8.078-5.485-12.023-1.145-2.493-2.5-4.932-3.727-7.387-1.318-2.646-2.9-5.214-4.152-7.518-1.716-3.16-3.517-5.946-5.274-8.873-1.692-2.818-3.589-5.645-5.355-8.334-2.326-3.542-4.637-6.581-7.039-9.848-2.064-2.809-4.017-5.255-6.088-7.828-2.394-2.974-4.937-5.936-7.292-8.589-3.027-3.411-6.049-6.744-9.055-9.763-2.4-2.412-4.776-4.822-7.108-6.975-3-2.767-5.836-5.471-8.692-7.854-3.332-2.779-6.657-5.663-9.815-8.028-2.958-2.216-5.784-4.613-8.7-6.6-3.161-2.159-6.251-4.414-9.219-6.254-3.814-2.365-7.533-4.882-11.168-6.89-4.213-2.327-8.513-4.909-12.478-6.834-4.61-2.239-9.234-4.619-13.51-6.416-4.1-1.725-8.11-3.505-11.874-4.888-4.5-1.652-8.506-3.191-12.584-4.47-6.045-1.9-12.071-3.678-17.431-5-9.228-2.284-17.608-3.757-24.951-4.9-7.123-1.112-13.437-1.64-18.271-2.035l-2.405-.2c-1.638-.136-3.508-.237-4.633-.3a115.051,115.051,0,0,0-12.526-.227h259.51Z' transform='translate(-8399.997 -164.445)' fill='%23fff'/%3E%3C/svg%3E%0A");
            position: absolute;
            bottom: 0;
            left: 0;
          }
          &::after {
            content: "";
            width: 20px;
            height: 20px;
            margin-right: -19px;
            transform: rotate(180deg) scale(1.04);
            background-size: 100%;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='259.51' height='259.52' viewBox='0 0 259.51 259.52'%3E%3Cpath id='Path_143' data-name='Path 143' d='M8659.507,423.965c-.167-2.608.05-5.319-.19-8.211-.084-1.012-.031-2.15-.118-3.12-.113-1.25-.1-2.682-.236-4.061-.172-1.722-.179-3.757-.365-5.394-.328-2.889-.478-5.857-.854-8.61-.509-3.714-.825-7.252-1.38-10.543-.934-5.535-2.009-11.312-3.189-16.692-.855-3.9-1.772-7.416-2.752-11.2-1.1-4.256-2.394-8.149-3.687-12.381-1.1-3.615-2.366-6.893-3.623-10.493-1.3-3.739-2.917-7.26-4.284-10.7-1.708-4.295-3.674-8.078-5.485-12.023-1.145-2.493-2.5-4.932-3.727-7.387-1.318-2.646-2.9-5.214-4.152-7.518-1.716-3.16-3.517-5.946-5.274-8.873-1.692-2.818-3.589-5.645-5.355-8.334-2.326-3.542-4.637-6.581-7.039-9.848-2.064-2.809-4.017-5.255-6.088-7.828-2.394-2.974-4.937-5.936-7.292-8.589-3.027-3.411-6.049-6.744-9.055-9.763-2.4-2.412-4.776-4.822-7.108-6.975-3-2.767-5.836-5.471-8.692-7.854-3.332-2.779-6.657-5.663-9.815-8.028-2.958-2.216-5.784-4.613-8.7-6.6-3.161-2.159-6.251-4.414-9.219-6.254-3.814-2.365-7.533-4.882-11.168-6.89-4.213-2.327-8.513-4.909-12.478-6.834-4.61-2.239-9.234-4.619-13.51-6.416-4.1-1.725-8.11-3.505-11.874-4.888-4.5-1.652-8.506-3.191-12.584-4.47-6.045-1.9-12.071-3.678-17.431-5-9.228-2.284-17.608-3.757-24.951-4.9-7.123-1.112-13.437-1.64-18.271-2.035l-2.405-.2c-1.638-.136-3.508-.237-4.633-.3a115.051,115.051,0,0,0-12.526-.227h259.51Z' transform='translate(-8399.997 -164.445)' fill='%23fff'/%3E%3C/svg%3E%0A");
            position: absolute;
            bottom: 0;
            right: 0;
          }
        }
        &:not(.top-menu--active) .top-menu__icon:before {
          content: "";
          z-index: -1;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          border-top-left-radius: 0.5rem;
          border-top-right-radius: 0.5rem;
          transition-property: background-color,
          border-color, color, fill, stroke, opacity, box-shadow, transform;
          transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
          transition-duration: 100ms;
        }
      }
      @keyframes intro-active-menu-animation {
        100% {
          z-index: 0;
        }
      }
      @keyframes intro-menu-animation {
        100% {
          opacity: 1;
          transform: translateX(0px);
        }
      }
      &:hover .top-menu:not(.top-menu--active) {
        // background-color: var(--bg-panel);
        background-color: var(--bg);
        // background-color: #dde2e9;
        // background-color: #fbfcff;
        // background-color: #faf8fb;
        color: var(--primary-color);
      }
      &:hover .dropdown {
        display: block;
      }
      .dropdown {
        list-style: none;
        margin: 0;
        padding: 0.5rem !important;
        // background-color: var(--primary-dark);
        background: rgb(52,43,126);
        background: linear-gradient(150deg, rgba(52,43,126,1) 0%, rgba(84,72,189,1) 70%, rgba(143,72,189,1) 100%, rgba(197,36,55,1) 100%);
        -webkit-box-shadow: 0 3px 20px rgba(0,0,0,.04);
        box-shadow: 0 3px 20px rgba(0,0,0,.04);
        display: none;
        width: 100%;
        position: absolute;
        border-radius: .375rem;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        z-index: 20;
        li {
          cursor: pointer;
          position: relative;
          .top-menu-side {
            height: 55px;
            border-top-left-radius: 1rem;
            border-top-right-radius: 1rem;
            display: flex;
            align-items: center;
            padding-left: 0;
            padding-right: 0;
            margin-right: 0;
            --text-opacity: 1;
            color: #fff;
            color: rgba(255, 255, 255, var(--text-opacity));
            position: relative;
            width: 100%;
            padding-left: 1.25rem !important;
            .top-menu__title {
              width: 100%;
              margin-left: 0.5rem;
              display: flex;
              align-items: center;
              white-space: nowrap;
              // color: #9f88f1;
              opacity: 0.75;
            }
            // .top-menu__icon:before {
            //   content: "";
            //   z-index: -1;
            //   position: absolute;
            //   width: 100%;
            //   height: 100%;
            //   top: 0;
            //   left: 0;
            //   border-radius: 0.5rem;
            //   transition-property: background-color,
            //   border-color, color, fill, stroke, opacity, box-shadow, transform;
            //   transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
            //   transition-duration: 100ms;
            // }
          }
          &:hover .top-menu-side {
            color: var(--color-text);
            font-weight: var(--heading-weight);
            transition-property: background-color,
            border-color, color, fill, stroke, opacity, box-shadow, transform;
            transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
            transition-duration: 100ms;
          }
          &:hover {
            transition: 0.5s ease;
            .top-menu__title {
              color: var(--bg);
              opacity: 1;
            }
            background-color: rgba(0, 0, 0, 0.04);
          }
        }
      }
    }
  }
}
</style>
